import { DependencyList, EffectCallback, useEffect } from "react";
import { useForceUpdate } from "@utils/useForceUpdate";

export function useDelayedEffect(effect: EffectCallback, deps?: DependencyList) {
    const [force, forceUpdate] = useForceUpdate();
    useEffect(() => forceUpdate, deps); // eslint-disable-line react-hooks/exhaustive-deps
    useEffect(effect, [effect, force]);
}